import axios from './axios';
import SETTINGS from '../settings'
export default {
  deleteNotification(id, cb) {
    axios.delete(`${SETTINGS.API_BASE_PATH}/usernotification/${id}`, ).then( () => {
      cb();
    }).catch(e => {
      console.log(e)
    })
  },
}